var DEFAULT_MEASUREMENT_ID = 'G-1LJN3HFVCW';
var getMeasurementId = function () { return process.env.REACT_APP_GA_MEASUREMENT_ID || DEFAULT_MEASUREMENT_ID; };
// Keep a module-scoped dispatcher. The Google tag can change globals after its
// script loads, while this dispatcher continues to write to the original queue
// that the tag initialized from.
var googleTagDispatcher;
var hasSkippedAutomaticInitialPageView = false;
export var initializeGoogleAnalytics = function () {
    if (typeof window === 'undefined' || process.env.REACT_APP_DISABLE_ANALYTICS === 'true') {
        return;
    }
    var measurementId = getMeasurementId();
    var googleWindow = window;
    if (googleTagDispatcher) {
        return;
    }
    var dataLayer = googleWindow.dataLayer || [];
    googleWindow.dataLayer = dataLayer;
    // Google Tag expects each command in its native `arguments` format, matching
    // the standard gtag.js snippet rather than a rest-parameter array.
    googleTagDispatcher = function googleTagDispatcher() {
        dataLayer.push(arguments);
    };
    googleWindow.gtag = googleTagDispatcher;
    googleTagDispatcher('js', new Date());
    // GA4 sends the first page view itself. React route changes are sent below.
    googleTagDispatcher('config', measurementId);
    var script = document.createElement('script');
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=".concat(encodeURIComponent(measurementId));
    script.dataset.googleAnalytics = measurementId;
    document.head.appendChild(script);
};
export var trackGoogleAnalyticsPageView = function (path, title) {
    if (typeof window === 'undefined' || process.env.REACT_APP_DISABLE_ANALYTICS === 'true') {
        return;
    }
    initializeGoogleAnalytics();
    if (!hasSkippedAutomaticInitialPageView) {
        hasSkippedAutomaticInitialPageView = true;
        return;
    }
    googleTagDispatcher === null || googleTagDispatcher === void 0 ? void 0 : googleTagDispatcher('event', 'page_view', {
        page_location: window.location.href,
        page_path: path,
        page_title: title || document.title,
    });
};
